import React from "react";
import PageHeader from "../components/PageHeader";
import ContactSection from "../components/ContactSection";

const Contact = () => {
  return (
    <>
      <PageHeader
        eyebrow="— Contact"
        title="Laten we kennismaken"
        subtitle="Wij luisteren graag naar uw vraag of probleem. Neem gerust contact op — wij reageren binnen 24 uur."
      />
      <ContactSection compact />
    </>
  );
};

export default Contact;
